'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formatDate = exports.useMinutes = exports.useHours = exports.useDays = exports.displayYearInDate = exports.showCountDownBasedOnMinimumDate = undefined;
exports.getCountDown = getCountDown;

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

require('moment-duration-format');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COUNTDOWN_CUTOFF_DAYS_HIGH = 7;
var COUNTDOWN_CUTOFF_DAYS_LOW = 2;
var COUNTDOWN_CUTOFF_HOURS_HIGH = 48;
var COUNTDOWN_CUTOFF_HOURS_LOW = 1;
var COUNTDOWN_CUTOFF_MINUTES = 59;

var showCountDownBasedOnMinimumDate = exports.showCountDownBasedOnMinimumDate = function showCountDownBasedOnMinimumDate(auctionDate) {
    var now = (0, _momentTimezone2.default)();
    var upcoming = _momentTimezone2.default.unix(auctionDate).tz(_momentTimezone2.default.tz.guess());
    var totalDays = upcoming.diff(now, 'days', true);

    if (totalDays <= COUNTDOWN_CUTOFF_DAYS_HIGH) {
        return true;
    }
    return false;
};

var displayYearInDate = exports.displayYearInDate = function displayYearInDate(now, upcoming) {
    if (now.year() !== upcoming.year() || now > upcoming) {
        return true;
    }
    return false;
};

var useDays = exports.useDays = function useDays(now, upcoming) {
    var totalDaysUntil = upcoming.diff(now, 'days', true);

    if (totalDaysUntil > COUNTDOWN_CUTOFF_DAYS_LOW && totalDaysUntil <= COUNTDOWN_CUTOFF_DAYS_HIGH) {
        return true;
    }
    return false;
};

var useHours = exports.useHours = function useHours(now, upcoming) {
    var totalHours = upcoming.diff(now, 'hours', true);

    if (totalHours <= COUNTDOWN_CUTOFF_HOURS_HIGH && totalHours >= COUNTDOWN_CUTOFF_HOURS_LOW) {
        return true;
    }
    return false;
};

var useMinutes = exports.useMinutes = function useMinutes(now, upcoming) {
    var totalMins = upcoming.diff(now, 'minutes', true);

    if (totalMins > 0 && totalMins <= COUNTDOWN_CUTOFF_MINUTES) {
        return true;
    }
    return false;
};

var formatDate = exports.formatDate = function formatDate(date) {
    return date.replace(/(\b\w)/gi, function (m) {
        return m.toUpperCase();
    });
};

function getCountDown(auctionDate) {
    var now = (0, _momentTimezone2.default)();
    var upcoming = _momentTimezone2.default.unix(auctionDate).tz(_momentTimezone2.default.tz.guess());
    var countDown = false;

    var dateFormat = displayYearInDate(now, upcoming) ? upcoming.format('MMM D, YYYY') : upcoming.format('MMM D');
    if (useDays(now, upcoming)) {
        var duration = _momentTimezone2.default.duration(upcoming.diff(now), 'ms');
        dateFormat = duration.format('d [days]');
        dateFormat = formatDate(dateFormat);
        countDown = true;
    } else if (useHours(now, upcoming)) {
        var _duration = _momentTimezone2.default.duration(upcoming.diff(now), 'ms');
        dateFormat = _duration.format('h [hours]');
        dateFormat = formatDate(dateFormat);
        countDown = true;
    } else if (useMinutes(now, upcoming)) {
        var _duration2 = _momentTimezone2.default.duration(upcoming.diff(now), 'ms');
        dateFormat = _duration2.format('m [mins]');
        dateFormat = formatDate(dateFormat);
        countDown = true;
    }

    return {
        countDown: countDown,
        dateFormat: dateFormat
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/countDown.js
// module id = 7bCi
// module chunks = 57